const OPENROUTER_API_URL = 'https://openrouter.ai/api/v1/chat/completions';
const DEFAULT_MODEL = 'openai/gpt-4o-mini';

const STORAGE_KEY = 'openrouter_api_key';

export const getStoredApiKey = () => localStorage.getItem(STORAGE_KEY) || '';
export const setStoredApiKey = (key) => {
  if (key) localStorage.setItem(STORAGE_KEY, key);
  else localStorage.removeItem(STORAGE_KEY);
};

const callOpenRouter = async (apiKey, messages, model = DEFAULT_MODEL) => {
  if (!apiKey) throw new Error('Укажите API ключ OpenRouter');
  const res = await fetch(OPENROUTER_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${apiKey}`,
      'HTTP-Referer': window.location.origin,
      'X-Title': 'NASCAR Admin',
    },
    body: JSON.stringify({
      model,
      messages,
      temperature: 0.7,
    }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`OpenRouter ошибка ${res.status}: ${text}`);
  }

  const data = await res.json();
  const content = data.choices?.[0]?.message?.content;
  if (!content) throw new Error('Пустой ответ от OpenRouter');
  return content;
};

const extractJson = (text) => {
  // Try to extract JSON array from markdown code block or raw string
  const codeBlockMatch = text.match(/```(?:json)?\s*([\s\S]*?)```/);
  const raw = codeBlockMatch ? codeBlockMatch[1].trim() : text.trim();
  return JSON.parse(raw);
};

export const generateCharacteristics = async (apiKey, { name, description, categoryName }) => {
  const messages = [
    {
      role: 'system',
      content: 'Ты помощник для интернет-магазина электротранспорта. Отвечай только JSON-массивом строк на русском языке.',
    },
    {
      role: 'user',
      content: `Составь список из 10-15 характеристик для товара на основе названия и описания. Характеристики должны быть в формате "Параметр: значение". Не добавляй пояснений, только JSON-массив строк.\n\nНазвание: ${name}\nКатегория: ${categoryName || 'не указана'}\nОписание: ${description || 'не указано'}`,
    },
  ];
  const content = await callOpenRouter(apiKey, messages);
  const parsed = extractJson(content);
  if (!Array.isArray(parsed)) throw new Error('Ответ не является массивом');
  return parsed.filter(item => typeof item === 'string');
};

export const generateReviews = async (apiKey, { name, description, categoryName }) => {
  const messages = [
    {
      role: 'system',
      content: 'Ты помощник для интернет-магазина электротранспорта. Отвечай только JSON-массивом объектов на русском языке.',
    },
    {
      role: 'user',
      content: `Сгенерируй 5 правдоподобных отзывов на товар. Каждый отзыв — объект с полями id (number), name (string, русские имена), comment (string, 1-2 предложения), stars (number от 4 до 5). Не добавляй пояснений, только JSON-массив.\n\nНазвание: ${name}\nКатегория: ${categoryName || 'не указана'}\nОписание: ${description || 'не указано'}`,
    },
  ];
  const content = await callOpenRouter(apiKey, messages);
  const parsed = extractJson(content);
  if (!Array.isArray(parsed)) throw new Error('Ответ не является массивом');
  return parsed.map((r, idx) => ({
    id: r.id || idx + 1,
    name: r.name || 'Покупатель',
    comment: r.comment || '',
    stars: r.stars || 5,
  }));
};
